import { format } from 'date-fns';
import { Timestamp } from 'firebase/firestore';
import { toast } from 'sonner';

/** Formats a Firestore Timestamp as a long localized date/time, or `—` if missing. */
export function formatTimestamp(value: Timestamp | null | undefined): string {
  if (!value || typeof value.toDate !== 'function') return '—';
  try {
    return format(value.toDate(), 'PPpp');
  } catch {
    return '—';
  }
}

/** Formats a JS Date / epoch ms as a long localized date/time, or `—` if missing. */
export function formatDateMs(ms: number | null | undefined): string {
  if (!ms || !Number.isFinite(ms)) return '—';
  try {
    return format(new Date(ms), 'PPpp');
  } catch {
    return '—';
  }
}

/** Copies a value to the clipboard and shows a toast describing the outcome. */
export async function copyToClipboard(value: string, label: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(value);
    toast.success(`${label} copied.`);
  } catch {
    toast.error(`Could not copy ${label.toLowerCase()}.`);
  }
}
